import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  HeaderContainer,
  HeaderLeftContainer,
  TitleContainer,
  IconWrapper,
  HeaderRightContainer,
} from "./Header.styled";
import { Typography, Icon, Button } from "@ann/web-components";

const Header = () => {
  const navigate = useNavigate();
  const { permissionId } = useParams();

  const handleBackClick = () => {
    if (permissionId) {
      navigate(`/v2/user-management/roles/${permissionId}/permissions`);
      return;
    }

    navigate("/v2/user-management/roles");
  };

  const handleEditPermissions = () => {
    console.log("Edit permissions clicked");
  };

  return (
    <HeaderContainer>
      <HeaderLeftContainer>
        <TitleContainer>
          <IconWrapper onClick={handleBackClick}>
            <Icon name="arrowLeft" size="medium" />
          </IconWrapper>
          <Typography category="title" size="small" weight="bold">
            Details Permissions
          </Typography>
        </TitleContainer>
        <Typography category="body" size="medium" weight="regular" color={"body"}>
          Sales manager
        </Typography>
      </HeaderLeftContainer>
      <HeaderRightContainer>
        <Button
          label="Edit permissions"
          size="medium"
          type="primary"
          onClick={handleEditPermissions}
        />
      </HeaderRightContainer>
    </HeaderContainer>
  );
};

export default Header;

